export function computeTitleFromName(name: string) {
    name = name.replace(/_/g, " ").replace(/([a-z0-9])&([A-Z])/g, "$1 $2")
    return name[0].toUpperCase() + name.slice(1)
}

export function formatPropertyName(name: string): string {
    if (!name) {
        return ""
    }

    // If name is exactly "easy_grant_id", return "EZG ID" (see ClickUp # 86adnc1jy )
    if (name === "easy_grant_id") {
        return "EZG ID"
    }

    return name
        .split("_")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(" ")
}

export function flattenObject(obj: any, prefix = "") {
    const result: { [key: string]: any } = {}

    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const newKey = prefix ? `${prefix}.${key}` : key

            if (typeof obj[key] === "object" && obj[key] !== null && !Array.isArray(obj[key])) {
                Object.assign(result, flattenObject(obj[key], newKey))
            } else if (Array.isArray(obj[key]) || typeof obj[key] === "number") {
                result[newKey] = JSON.stringify(obj[key])
            } else {
                result[newKey] = obj[key]
            }
        }
    }

    return result
}